import React from "react";
import { FormGroup, Input, Label } from "reactstrap";
import { Search, X } from "react-feather"

interface ISearchBarProp {
    value: string,
    placeholder?: string,
    onChange?: (e:any)=>void,
    onReset?: (e:any)=>void
}

interface ISearchBarState {
  isSearched: boolean
}

class SearchBar extends React.Component<ISearchBarProp, ISearchBarState> {

    state = {
        isSearched: false
    }
  
    componentDidMount = () => {
      this.setState({isSearched: false})
    }

    onChange = (e:any) => {
      if(this.props.onChange)
        this.props.onChange(e);
      this.setState({isSearched: true});
    }

    onReset = (e:any) => {
      this.setState({isSearched: false})
      if(this.props.onReset)
        this.props.onReset(e);
    }

    render() {
      const { isSearched } = this.state;
    return (
        <div className="_library-searchbar">
            <FormGroup className="position-relative mb-0">
                <Input
                    className="w-100 mr-1 mb-sm-0 search-product"
                    type="text"
                    placeholder="search..."
                    onChange={e => this.onChange(e)}
                    value={this.props.value}
                />
                <div className="form-control-position">
                    { isSearched ? <X size={22} onClick={(e)=> this.onReset(e)} /> : <Search size={22} />}
                </div>
            </FormGroup>
      </div>
    );
  }
}
export default SearchBar;
